(function() {
  'use strict';

  class FilterForm {
    constructor(node) {
      this.form = node;
      this.initListener();
    }
    initListener() {
      this.form.addEventListener('submit', e => {
        e.preventDefault();
        this.onSubmit();
      })
      Array.from(this.form.querySelectorAll('input[type=checkbox][location=CollectionSidebar]')).forEach(input => {
        input.addEventListener('change', e => {
          e.preventDefault();
          this.onSubmit();
        })
      });
      Array.from(this.form.querySelectorAll('[link_to_remove_tag]')).forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault();
          const formData = Object.fromEntries(new FormData(this.form));
          window.location.href = `${link.dataset.href}?${new URLSearchParams(formData).toString()}`;
        })
      })
    }
    onSubmit() {
      const baseUrl = this.form.dataset.baseUrl;
      const formData = Object.fromEntries(new FormData(this.form));
      const apply_tags = Array.from(this.form.querySelectorAll('input[type=checkbox].tag__input--tag:checked')).map(tag => tag.value);
      if (window.location.href.includes('/search')) {
        apply_tags.push((new URLSearchParams(window.location.search)).get('q'));
        window.location.href = `/search?type=product&q=${apply_tags.join('/')}&${new URLSearchParams(formData).toString()}`;
        return;
      }
      window.location.href = `${baseUrl}${apply_tags.length ? '/' + apply_tags.join('+') : ''}?${new URLSearchParams(formData).toString()}`;
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('form.form-filter')).forEach(form => {
      new FilterForm(form);
    });

    Array.from(document.querySelectorAll('.sidebar__more-button')).forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault();
        const container = button.closest('.collapsible-content');
        container.style.height = 'auto';
        Array.from(container.querySelectorAll('.hide')).forEach(item => {
          item.classList.remove('hide');
          button.classList.add('hide');
        });
      })
    })
  })
})();